import * as React from 'react'
import { appTheme } from '../../theme'
import { Box, LinearProgress, Typography, useMediaQuery } from '@mui/material'
import './ProgressBar.css'
import eventInfo from '../../images/StepperBar/EventInfo.svg'
import speakersAndStaff from '../../images/StepperBar/SpeakersAndSupportStaff.svg'
import audience from '../../images/StepperBar/Audience.svg'
import dateAndTimes from '../../images/StepperBar/DatesAndTimes.svg'
import featuresAndRequests from '../../images/StepperBar/FeaturesAndRequests.svg'
import reviewAndSubmit from '../../images/StepperBar/ReviewAndSubmit.svg'
import { flexItemSpaceBetween } from '../../global'
import { useEffect } from 'react'
import { eventDetail } from '../../services/EventService'
import { useNavigate, useParams } from 'react-router-dom'
import { EventType } from '../../services/Types'

export interface ProgressBarProps {
  activePageTitle?: string
  requestType?: string
}

let stepsIcon = {
  'Event Info': eventInfo,
  'Speakers & Staff': speakersAndStaff,
  'Date & Times': dateAndTimes,
  'Features & Requests': featuresAndRequests,
  'Review & Submit': reviewAndSubmit,
  Audience: audience
}

// Initialize the variable to check Mobile view
var isMobileView = false
var isWebView = true

export const ProgressBar: React.FC<ProgressBarProps> = ({
  activePageTitle,
  requestType
}) => {
  // Define the pages
  let steps = [
    'Event Info',
    'Speakers & Staff',
    'Date & Times',
    'Features & Requests',
    'Review & Submit'
  ]
  if (requestType === EventType.SERIES) {
    steps = [
      'Event Info',
      'Speakers & Staff',
      'Features & Requests',
      'Date & Times',
      'Review & Submit'
    ]
  }

  const [showErrorMessage, setErrorMessage] = React.useState('')
  const showErrorPopup = (message: string) => {
    setErrorMessage(message)
    setTimeout(() => {
      setErrorMessage('')
    }, 3000)
  }

  let { id } = useParams()
  const navigate = useNavigate()
  const [eventType, setEventType] = React.useState<any>()

  useEffect(() => {
    const loadEventData = async () => {
      try {
        const { data } = await eventDetail(Number(id))
        if (data) {
          if (data.eventDetail.statusCode === 200) {
            if (data.eventDetail.data === null) {
              navigate('/')
            } else {
              setEventType(data.eventDetail.data.eventType)
            }
          }
        }
      } catch (error) {
        showErrorPopup('Internal server error')
      }
    }
    if (id !== undefined) {
      loadEventData()
    }
  }, [])

  React.useLayoutEffect(() => {
    if (eventType === 'Webinar') {
      steps.splice(2, 0, 'Audience')
    }
  }, [eventType])

  if (requestType === 'Webinar') {
    steps.splice(2, 0, 'Audience')
  }

  isMobileView = useMediaQuery(appTheme.breakpoints.down('md'))
  isWebView = !useMediaQuery(appTheme.breakpoints.down('lg'))

  // Update Progress value
  const [progress, setProgress] = React.useState(
    ((steps.indexOf(activePageTitle as string) + 1) / (steps.length + 1)) * 100
  )

  let preRequestType = ''
  useEffect(() => {
    setProgress(
      ((steps.indexOf(activePageTitle as string) + 1) / (steps.length + 1)) *
        100
    )
  }, [activePageTitle])
  useEffect(() => {
    if (preRequestType !== requestType) {
      preRequestType = requestType as string
      setProgress(
        ((steps.indexOf(activePageTitle as string) + 1) / (steps.length + 1)) *
          100
      )
    }
  }, [requestType])

  return (
    <Box sx={{ backgroundColor: 'white' }}>
      <Box
        style={flexItemSpaceBetween}
        sx={{
          minHeight: { sm: 145 },
          px: '20px',
        }}
      >
        {steps.map((step, index) => (
          <Box
            key={index}
            boxShadow={
              step == (!isMobileView && activePageTitle)
                ? '0px 2px 16px rgba(0, 0, 0, 0.08)'
                : 'none'
            }
            sx={{
              borderRadius: '8px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              py: '14px',
              px: '4px'
            }}
          >
            <Box
              color={step != activePageTitle ? 'disabled' : 'action'}
              component='img'
              src={stepsIcon[step as keyof typeof stepsIcon]}
              alt={step}
              sx={{
                mb: '8px',
                opacity: step != activePageTitle ? 0.75 : 1,
                width: '22px'
              }}
            />
            {!isMobileView && (
              <Typography
                fontWeight={step == activePageTitle ? 400 : 400}
                sx={{
                  fontSize: { lg: '16px !important', md: '15px', sm: '14px' },
                  lineHeight: { lg: '19.36px', md: '17.54px', sm: '16.94px' },
                  letter: '-2%',
                  opacity: step != activePageTitle ? 0.75 : 1
                }}
              >
                {step}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
      <Box sx={{ width: 'auto' }}>
        <LinearProgress
          sx={{ backgroundColor: 'transparent' }}
          variant='determinate'
          color='success'
          value={progress}
        />
      </Box>
    </Box>
  )
}
